window.app_models.payment_request = {
    "id":null,
    "what_for": null,
    "payable_to": null,
    "payable": null,
    "budget_id": null,
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/payment_request.js